import { LWC_MANUAL_PDF_PATH } from "../../constants/ConstantVars";

const navAuth = (intl) => ({
  items: [
    /*{
      name: 'Profile',
      url: '/student/studentprofile',
      icon: 'icon-user',
      badge: {
        // variant: 'info',
        // text: 'Info'
      }
    },*/
    {
      name: intl.formatMessage({ id: "Results" }),
      url: "/student/studentresults",
      icon: "icon-list",
      badge: {},
    },
    {
      name: intl.formatMessage({ id: "Manual" }),
      url: LWC_MANUAL_PDF_PATH,
      icon: "circle-info",
      bage: {},
    },
  ],
});

export default navAuth;
